<template lang="pug">
.comments-card-list
  .comments-card-list__toggle(
    v-if="!loading"
    :class="{'-active-': isOpen}"
    @click="toggleOpen"
  )
    span(v-if='!isOpen') Показать предыдущие комментарии ({{count}})
    span(v-else) Свернуть предыдущие комментарии ({{count}})
  .ajax__line.comments-card-list__toggle(v-else)
  SlideUpDown(:active="isOpen && !loading" :duration="300").comments-card-list__list
    Comment.comments-card-list__item(
      v-for="(comment, idx) in comments"
      :comment="comment"
      :key="idx")

</template>

<script>
import Comment from './Comment';
import SlideUpDown from 'vue-slide-up-down';

export default {
  components: { Comment, SlideUpDown },
  props: {
    answer: {},
    count: {}
  },
  data: () => ({
    isOpen: false,
    loading: false,
    comments: []
  }),
  methods: {
    toggleOpen() {
      if (!this.comments.length && !this.loading) {
        this.getLastComments();
      }

      this.isOpen = !this.isOpen;
    },
    async getLastComments() {
      this.loading = true;
      const res = await this.$store.dispatch(
        'answersComments/getLastComments',
        this.answer
      );
      if (res.status === 'success') {
        this.comments = res.data;
      }

      this.loading = false;
    }
  }
};
</script>
